import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-197462c2")

_pushScopeId("data-v-197462c2")
const _hoisted_1 = { class: "full-width" }
const _hoisted_2 = { class: "flex flex--width flex--v flex--gap-20" }
const _hoisted_3 = { class: "flex flex--v flex--gap-5" }
const _hoisted_4 = { class: "flex flex--v flex--gap-5" }
const _hoisted_5 = { class: "flex flex--v flex--gap-5" }
const _hoisted_6 = { class: "flex flex--v flex--gap-5" }
const _hoisted_7 = { class: "flex flex--width flex--v flex--valign-c flex--gap-20" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_breeze_label = _resolveComponent("breeze-label")
  const _component_breeze_input = _resolveComponent("breeze-input")
  const _component_GenericButton = _resolveComponent("GenericButton")
  const _component_InertiaLink = _resolveComponent("InertiaLink")

  return (_openBlock(), _createBlock("form", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_breeze_label, {
          for: "name",
          value: _ctx.$trans('auth.name')
        }, null, 8, ["value"]),
        _createVNode(_component_breeze_input, {
          id: "name",
          modelValue: _ctx.form.name,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.name = $event)),
          type: "text",
          required: "",
          autofocus: "",
          autocomplete: "name"
        }, null, 8, ["modelValue"])
      ]),
      _createVNode("div", _hoisted_4, [
        _createVNode(_component_breeze_label, {
          for: "email",
          value: _ctx.$trans('auth.email')
        }, null, 8, ["value"]),
        _createVNode(_component_breeze_input, {
          id: "email",
          modelValue: _ctx.form.email,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.email = $event)),
          type: "email",
          required: "",
          autocomplete: "username"
        }, null, 8, ["modelValue"])
      ]),
      _createVNode("div", _hoisted_5, [
        _createVNode(_component_breeze_label, {
          for: "password",
          value: _ctx.$trans('auth.password')
        }, null, 8, ["value"]),
        _createVNode(_component_breeze_input, {
          id: "password",
          modelValue: _ctx.form.password,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.password = $event)),
          type: "password",
          required: "",
          autocomplete: "new-password"
        }, null, 8, ["modelValue"])
      ]),
      _createVNode("div", _hoisted_6, [
        _createVNode(_component_breeze_label, {
          for: "password_confirmation",
          value: _ctx.$trans('auth.password_confirm')
        }, null, 8, ["value"]),
        _createVNode(_component_breeze_input, {
          id: "password_confirmation",
          modelValue: _ctx.form.password_confirmation,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.form.password_confirmation = $event)),
          type: "password",
          class: "mt-1 block w-full",
          required: "",
          autocomplete: "new-password"
        }, null, 8, ["modelValue"])
      ]),
      _createVNode("div", _hoisted_7, [
        _createVNode(_component_GenericButton, {
          type: "submit",
          class: "login-button",
          title: _ctx.$trans('auth.register'),
          disabled: _ctx.form.processing,
          "click-stop": false
        }, null, 8, ["title", "disabled"]),
        _createVNode(_component_InertiaLink, {
          href: _ctx.route('login'),
          class: "inertia-link text text--less-gap text--primary-b text--size-16 text--center"
        }, {
          default: _withId(() => [
            _createTextVNode(_toDisplayString(_ctx.$trans("auth.already_registered")), 1)
          ]),
          _: 1
        }, 8, ["href"])
      ])
    ])
  ]))
})